export default __webpack_public_path__ + "help.b4f44fea.svg";